import React from "react";
import Col from "react-bootstrap/Col";
import SwiperCore, { Autoplay } from "swiper";
import { connect } from "react-redux";
import { getHomeOffers } from "../../../redux/actions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { homepage_offer_image } from '../../../all_constant';
import "swiper/css";
import "swiper/css/pagination";

const HomeOffers = (props) => {
  SwiperCore.use([Autoplay]);
  const { getHomeOffersList,getHomeOffersAction, loading, error, messages } = props;
  console.log("check---", getHomeOffersList, loading, error, messages);

   React.useEffect(() => {
     fetchData();
   }, []);

   const fetchData = () => {
     getHomeOffersAction(1);
   };

   

  return (
    <>
    { getHomeOffersList.length > 0 ? 
      <section className="offers-wrap">
        <div className="offer-slider-wrap container">
          <Col md={12}>
            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              loop={false}
              speed={1000}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                576: {
                  // width: 576,
                  slidesPerView: 2,
                },
                768: {
                  // width: 768,
                  slidesPerView: 4,
                },
                1024: {
                  // width: 768,
                  slidesPerView: 4,
                },
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
            {getHomeOffersList && getHomeOffersList.map((item) => (
              <SwiperSlide className="p-1 swiper-slider-wrap ">
                <div className="offer-slider-content">
                  <img src={`${homepage_offer_image}/${item.Image}`} alt="Banner Promotion" />
                  <h2>{item.Title}</h2>
                  <p>{item.SubTitle}</p>
                </div>
              </SwiperSlide>
            ))}
            </Swiper>
          </Col>
        </div>

      </section>
      : 
      <section></section>
    }
    </>
  );
};


 const mapStateToProps = ({ discountoffer }) => {
  const { loading, error, messages, getHomeOffersList } = discountoffer;
   return { loading, error, messages, getHomeOffersList };
 };

 export default connect(mapStateToProps, {
   getHomeOffersAction: getHomeOffers,
 })(HomeOffers);
